import {groupFromPage} from "../GroupMapper";
import {areConditionsTrue} from "../../utils";

export async function sortPagesAndCreateDefaultValues(pages)  {
    pages.sort((a, b) => a.b2cStep - b.b2cStep);
    const defaultValues = pages.reduce((acc, page) => {
        acc[page.key] = page.defaultValue ?? null;
        return acc;
    }, {});
    return {sortedPages: pages, defaultValues};
}

export async function createGroupingsAndDefaultValues(pages) {
    const groups = [];
    const {sortedPages, defaultValues} = await sortPagesAndCreateDefaultValues(pages);
    sortedPages.forEach((page) => {
        let group = groups.find(g => g.name === page.groupName);
        if (!group) {
            group = groupFromPage(page);
            groups.push(group);
        }

        group.entries.push(page);
    });
    groups.sort((a, b) => a.order - b.order);

    return {groups, defaultValues};
}

export async function filterPages(pages, responseArray) {
    return pages.filter(entry => {
        if (!entry.conditions) return true;

        return areConditionsTrue(entry.conditions, responseArray);
    });
}

export async function filterShownGroupedPages(groups, responseArray) {
    return Promise.all(groups
        // Shallow clone group
        .map(async (group) => {
            return {
            ...group,
                // overwrite entries with filtered inputs
                entries: await filterPages(group.entries, responseArray),
            };
        })
    );
}
